export default __webpack_public_path__ + "static/media/Unknown.2bde781f.png";